import Alpine from "alpinejs";
import collapse from "@alpinejs/collapse";
import focus from "@alpinejs/focus";

import "./stores/docOverflow";

import "./components/menu";
import "./components/slider";
import "./components/checklistSection";
import "./components/scrollPosition";
import "./components/dynamicSticky";
import "./components/newWindowLinks";
import "./components/inputList";

Alpine.plugin([collapse, focus]);
window.Alpine = Alpine;

Alpine.start();
